// extracted by mini-css-extract-plugin
export var chevron = "_q2-1";
export var clickable = "_q2-0";
export var ruleRow = "_q2-2";